import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox } from '@lichtblick/photon/atoms/legacy-checkbox/checkbox';
import { Label } from '@lichtblick/photon/molecules/label/label';
import { useId, useState } from 'react';
import styles from './OptionalSubsection.module.scss';
export const OptionalSubsection = ({ children, icon, isOpen, label })=>{
    const id = useId();
    const [isSelected, setIsSelected] = useState(isOpen);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.option,
        "data-selected": isSelected,
        children: [
            /*#__PURE__*/ _jsxs(Label, {
                bold: true,
                htmlFor: id,
                children: [
                    /*#__PURE__*/ _jsx(Checkbox, {
                        defaultChecked: isOpen,
                        id: id,
                        onChange: ({ target })=>setIsSelected(target.checked)
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: label
                    }),
                    icon
                ]
            }),
            /*#__PURE__*/ _jsx("fieldset", {
                "aria-disabled": !isSelected,
                disabled: !isSelected,
                children: /*#__PURE__*/ _jsx("div", {
                    children: children
                })
            })
        ]
    });
};

//# sourceMappingURL=OptionalSubsection.js.map